import { HTTP } from '../../http-common'

export default {
  state: {
    loadedSexes: []
  },
  getters: {
    loadedSexes (state) {
      return state.loadedSexes
    }
  },
  mutations: {
    setLoadedSexes (state, payload) {
      state.loadedSexes = payload
    },
    createSex (state, payload) {
      state.loadedSexes.push(payload)
    },
    updateSex (state, payload) {
      state.loadedSexes = state.loadedSexes.map(sex => sex.id === payload.id ? payload : sex)
    },
    removeSex (state, id) {
      state.loadedSexes = state.loadedSexes.filter(sex => {
        return sex.id !== id
      })
    },
    clearLoadedSexes (state) {
      state.loadedSexes = []
    }
  },
  actions: {
    loadSexes ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedSexes', [])

      return new Promise((resolve, reject) => {
        HTTP.get('sex.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedSexes', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createSex ({ commit, getters }, payload) {
      console.log('createSex')
      commit('clearError')
      commit('setLoading', true)
      const newSex = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('sex.json/', newSex)
          .then(result => {
            console.log(result)
            commit('createSex', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateSex ({ commit, getters }, payload) {
      console.log('updateSex')
      commit('clearError')
      commit('setLoading', true)
      const sex = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`sex.json/${payload.id}/`, sex)
          .then(result => {
            console.log(result)
            commit('updateSex', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeSex ({ commit }, payload) {
      console.log('removeSex')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`sex.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeSex', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedSexes ({ commit }) {
      commit('clearLoadedSexes')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sex/index.js